import moment from "moment";
import { PropertyBuildingInteractor, PropertyBuildRequest, PropertyBuildStructRequest } from "../../Coordinator/PropertyBuilding/PropertyBuildingInteractor";

export class PropertyBuildingViewModel {
	private interactor: PropertyBuildingInteractor;

	constructor() {
		this.interactor = new PropertyBuildingInteractor();
	}

	public fetchPerson(): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.fetchPerson().then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchKinship(): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.fetchKinship().then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new PropertyBuildStructRequest(
			obj["sgeppropedificacoes"] ? parseInt(obj["sgeppropedificacoes"]) : 0
		)

		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var objProperty = obj['proprietarios'] as Array<any>
		var objResident = obj['residentes'] as Array<any>

		var request = new PropertyBuildRequest(
			obj['sgeppropedificacoes'] ? parseInt(obj['sgeppropedificacoes']) : 0,
			obj['sgeppropriedade'] ? parseInt(obj['sgeppropriedade']) : 0,
			obj['descricao'] ? obj['descricao'] : '',
			obj['inscricao'] ? obj['inscricao'] : '',
			obj['sgeptipotumulo'] ? parseInt(obj['sgeptipotumulo']) : 0,
			objProperty,
			objResident,
			obj['tipoarquitetonico'] ? parseInt(obj['tipoarquitetonico']) : 0,
			obj['sgepcategoriaconstrucao'] ? parseInt(obj['sgepcategoriaconstrucao']) : 0,
			obj['valorm2construcao'] ? parseFloat(obj['valorm2construcao']) : 0,
			obj['valorvenalconstrucao'] ? parseFloat(obj['valorvenalconstrucao']) : 0,
			// obj['numerounidade'] ? parseFloat(obj['numerounidade']) : 0,
			obj['areaconstruida'] ? parseFloat(obj['areaconstruida']) : 0,
			obj['aliquotaconstrucao'] ? parseFloat(obj['aliquotaconstrucao']) : 0,
			obj['aliquotaunidade'] ? parseFloat(obj['aliquotaunidade']) : 0,
			// obj['padraom2'] ? parseFloat(obj['padraom2']) : 0,			
			obj['sgepanoconclusao'] ? parseInt(obj['sgepanoconclusao']) : 0,
			obj['sgeptipoconstrucao'] ? parseInt(obj['sgeptipoconstrucao']) : 0,

		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchTypeOfGrave(): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.fetchTypeOfGrave().then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}

}